var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarHalf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3023 0.509766V16.4744L5.14574 19.764L6.32233 12.7971L1.34033 7.86432L8.22403 6.84832L11.3023 0.509766Z",
    fill: "#FFD166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41332 8.2188L6.67018 12.435C6.78803 12.5517 6.84198 12.7192 6.81401 12.8836L5.80821 18.8365L11.0699 16.026C11.2147 15.9478 11.3895 15.9478 11.5343 16.026L16.794 18.8365L15.7902 12.8836C15.7622 12.7192 15.8161 12.5517 15.934 12.435L20.1899 8.2188L14.308 7.35098C14.1462 7.32662 14.0043 7.22308 13.9324 7.07286L11.3016 1.65695L8.67176 7.07286C8.59885 7.22308 8.45804 7.32662 8.29624 7.35098L2.41332 8.2188ZM5.14504 20.2716C5.04216 20.2716 4.93828 20.2392 4.85139 20.1742C4.69757 20.0605 4.62066 19.8687 4.65262 19.6789L5.78526 12.9749L0.992031 8.2279C0.855196 8.09291 0.80727 7.89094 0.8652 7.70824C0.924129 7.52352 1.08093 7.39055 1.26871 7.36213L7.89172 6.38473L10.8541 0.285732C11.0219 -0.0613899 11.5822 -0.0613899 11.75 0.285732L14.7115 6.38473L21.3345 7.36213C21.5223 7.39055 21.6791 7.52352 21.738 7.70824C21.7959 7.89094 21.747 8.09291 21.6112 8.2279L16.8189 12.9749L17.9506 19.6789C17.9825 19.8687 17.9056 20.0605 17.7508 20.1742C17.597 20.2889 17.3933 20.3031 17.2255 20.2128L11.3016 17.0491L5.37773 20.2128C5.30482 20.2523 5.22494 20.2716 5.14504 20.2716Z",
    fill: "#FFD166"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.a9a4e67a.svg";
export { ForwardRef as ReactComponent };